import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=06e84278"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=06e84278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports